<template>
  <section class="main-info-edit">
    <h2
      class="title-small"
      style="margin-bottom: 39px"
    >
      {{ $t('mainInfo.title') }}
    </h2>
    <MainInfo
      :input-name="inputName"
      :phone-value="phoneValue"
      :name="name"
      :logo="logo"
      :icon-chat="iconChat"
      :show-icon-chat="showIconChat"
      :value-location="valueLocation"
      :working-all="workingAll"
      :value-county="valueCounty"
      show-popup-after-crop="#edit-info"
      @nameChange="valueName = $event"
      @logoChange="logo = $event"
      @iconChatChange="iconChat = $event"
      @valueLocationChange="valueLocation = $event"
      @workingAllChange="workingAll = $event"
      @valueCountyChange="valueCounty = $event"
      @phoneValueChange="phoneValue = $event"
      @phoneValid="phoneValid = $event"
    />
    <ButtonsBottom :disabledSave="!phoneValid"/>
  </section>
</template>

<script>
    import MainInfo from '../factory/parts/MainInfo.vue'
    import ButtonsBottom from '../ButtonsBottom.vue'

    export default {
        name: 'MainInfoEdit',
        components: { ButtonsBottom, MainInfo },
        props: {
            nameStart: {},
            phoneValueStart: {},
            logoStart: {},
            iconChatStart: {},
            valueLocationStart: {},
            workingAllStart: {},
            valueCountyStart: {},
            inputName: {
                required: true,
                type: String,
            },
            showIconChat: {
                default: false,
                type: Boolean,
            },
        },
        data: () => ({
            name: '',
            phoneValue: '',
            phoneValid: '',
            logo: null,
            iconChat: null,
            valueLocation: '',
            valueCounty: [],
            workingAll: false,
        }),
        beforeMount() {
            if (this.nameStart) {
                this.name = this.nameStart
            }
            if (this.phoneValueStart) {
                this.phoneValue = (`+ ${this.phoneValueStart}`)
            }
            if (this.logoStart) {
                this.logo = this.logoStart
            }
            if (this.iconChatStart) {
                this.iconChat = this.iconChatStart
            }
            if (this.valueLocationStart) {
                this.valueLocation = this.valueLocationStart
            }

            this.workingAll = !!this.workingAllStart
            if (this.valueCountyStart) {
                this.valueCounty = this.valueCountyStart
            }
        },
    }
</script>

<style scoped>

</style>
